// Supplier portal sign-in (Lane 1331). The server gives the same answer for an
// unknown email, a wrong password and a locked account; the page shows it.
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PublicShell } from './PortalShell';
import { portalApi, getPortalToken, setPortalToken, PORTAL_HOME } from './portalApi';

export default function LoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  // Already signed in: go to the events. A token that is no longer valid is
  // cleared by the next signed-in request, which sends the browser back here.
  useEffect(() => {
    if (getPortalToken()) navigate(PORTAL_HOME, { replace: true });
  }, [navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setSaving(true);
    try {
      const r = await portalApi.login(email.trim(), password);
      setPortalToken(r.token);
      navigate(PORTAL_HOME, { replace: true });
    } catch (err) {
      setError(err.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <PublicShell>
      <form className="srcp-card" onSubmit={submit}>
        <div className="srcp-card-h"><h1 className="srcp-card-t srcp-h2">Sign in</h1></div>
        <div className="srcp-card-b srcp-card-b--form">
          <div className="srcp-signin-note">Use the email and password you set when you accepted an invitation.</div>
          <div className="srcp-field">
            <label className="srcp-label" htmlFor="srcp-login-email">Email</label>
            <input id="srcp-login-email" className="srcp-input" type="email" value={email} maxLength={255}
              autoComplete="email" onChange={(e) => setEmail(e.target.value)} />
          </div>
          <div className="srcp-field">
            <label className="srcp-label" htmlFor="srcp-login-pw">Password</label>
            <input id="srcp-login-pw" className="srcp-input" type="password" value={password} maxLength={200}
              autoComplete="current-password" onChange={(e) => setPassword(e.target.value)} />
          </div>
          {error && <div className="srcp-error" role="alert">{error}</div>}
          <div>
            <button type="submit" className="srcp-btn srcp-btn--primary" disabled={saving || !email.trim() || !password}>
              {saving ? 'Signing in…' : 'Sign in'}
            </button>
          </div>
        </div>
      </form>
    </PublicShell>
  );
}
